import React, { FC, useState, useCallback, FormEvent, useMemo } from 'react'
import { Button, Input, Typography } from '@material-tailwind/react'
import { useXp } from '../contexts/XpContext'
import { useScreenBreakpoint } from '../hooks/toolkit'

interface ManualSpotProps {
  onPlay: (spot: string) => void
}

const ManualSpot: FC<ManualSpotProps> = ({ onPlay }) => {
  const [manualSpot, setManualSpot] = useState<string>()
  const { patterns } = useXp()
  const breakpoint = useScreenBreakpoint()

  const handlePlay = useCallback(
    (e: FormEvent) => {
      e.preventDefault()
      e.stopPropagation()
      if (!manualSpot) return
      onPlay(manualSpot)
    },
    [onPlay, manualSpot]
  )

  const bottom = useMemo(() => {
    if (breakpoint === 'sm') return 0
    if (patterns.length > 1) return 84
    return 24
  }, [patterns, breakpoint])

  return (
    <div
      className={`
        absolute w-full md:w-[36rem]
        md:left-1/2 md:-translate-x-1/2
        shadow rounded overflow-hidden z-[999]
        px-4 md:px-6 py-4
        bg-white dark:bg-primary-500
      `}
      style={{ bottom }}
      data-testid="manual-spot-card"
    >
      <form onSubmit={handlePlay}>
        <Typography className="pb-1">Play manual spot</Typography>
        <div className="flex items-center gap-x-2">
          <Input
            className="flex-1"
            value={manualSpot || ''}
            onChange={(e) => setManualSpot(e.currentTarget.value)}
            type="text"
            placeholder="Code"
            data-testid="manual-spot-input"
          />
          <Button type="submit" data-testid="manual-spot-play-btn">
            PLAY
          </Button>
        </div>
      </form>
    </div>
  )
}

export default ManualSpot
